import { NgControl } from '@angular/forms';
import { Directive, HostListener, OnInit } from '@angular/core';

@Directive({
    selector: '[appPhoneMask]',
})
export class PhoneMaskDirective implements OnInit {
    constructor(public model: NgControl) {}

    ngOnInit(): void {
        this.onInputChange(this.model.value);
    }

    @HostListener('input', ['$event'])
    onEvent(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.onInputChange(input.value);
    }

    onInputChange(value: string): void {
        if (value) {
            let digitsOnly = value.replace(/\D/g, '');

            if (digitsOnly.length === 0 && value !== '(') {
                this.updateValue('');
            } else if (digitsOnly.length <= 3) {
                this.updateValue(`(${digitsOnly}`);
            } else if (digitsOnly.length <= 6) {
                this.updateValue(`(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`);
            } else if (digitsOnly.length <= 10) {
                this.updateValue(`(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3, 6)}-${digitsOnly.slice(6)}`);
            } else {
                let lastTenDigits = digitsOnly.slice(-10);
                this.updateValue(`(${lastTenDigits.slice(0, 3)}) ${lastTenDigits.slice(3, 6)}-${lastTenDigits.slice(6)}`);
            }
        } else {
            this.updateValue('');
        }
    }

    private updateValue(value: string): void {
        this.model.valueAccessor.writeValue(value);
        if (this.model.control) {
            this.model.control.setValue(value, { emitEvent: false });
        }
    }
}
